var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2673 0.20889C9.9674 -0.0768002 9.4926 -0.06525 9.2069 0.23467C8.9212 0.5346 8.9328 1.00933 9.2327 1.29502L15.4841 7.2496H0.75C0.33579 7.2496 0 7.5854 0 7.9996C0 8.4138 0.33579 8.7496 0.75 8.7496H15.4842L9.2327 14.7043C8.9328 14.99 8.9212 15.4648 9.2069 15.7647C9.4926 16.0646 9.9674 16.0762 10.2673 15.7905L17.6862 8.7238C17.8551 8.5629 17.9551 8.3576 17.9861 8.1443C17.9952 8.0975 18 8.0491 18 7.9996C18 7.9501 17.9952 7.9016 17.986 7.8547C17.955 7.6415 17.855 7.4364 17.6862 7.2756L10.2673 0.20889Z",
    fill: "#161616"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/ArrowIcon.b5a487d3e4c3d4363943f41bdd550f77.svg";
export { ForwardRef as ReactComponent };